var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureIcon32({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_752_2714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3749 0H3.75V3.67533H18.3749V0Z",
    fill: "#FFBC07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3966 30.4849V26.9624V23.2871H3.69531V26.9624V30.6378V37.9884H7.37064H11.046H18.3966V34.3131V30.4849ZM11.046 34.3131H7.37064V30.6378V26.9624H11.046H14.7213V30.4849V34.3131H11.046Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9982 10.8736V7.35111V3.67578H23.2969V7.35111V11.0264V18.3771H26.9722H30.6475H37.9982V14.7018V10.8736ZM26.9722 14.7018V7.35111H34.3229V14.7018H26.9722Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7013 3.67578V7.35111V10.8736V14.7018H11.026H7.35067H3.67533V11.0264V7.35111V3.67578H0V7.35111V11.0264V14.7018V18.3771H3.67533H7.35067H11.026H14.7013H18.3767V15.7544V14.7018V10.8736V7.35111V5.99859V3.67578H14.7013Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.67533 0H0V3.67533H3.67533V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9982 30.4378V26.98V23.3047H26.9722H23.2969V30.6554V38.006H37.9982V34.3307V30.4378ZM30.6475 34.3307H26.9722V30.6554V26.98H30.6475H34.3229V30.4378V34.3307H30.6475Z",
    fill: "#2650FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_752_2714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38.0059,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon32);
export default __webpack_public_path__ + "static/media/feature_icon_3_2.b5a57359548d038d47fcfa353463e2ca.svg";
export { ForwardRef as ReactComponent };